import Program from '../../program.js'
import oceanFile from 'url:./ocean.png'
import * as tools from '../../tools.js'
import {SpriteMap, Animation} from '../../graphics.js'

export default new Program((computer) => {
  return tools.loadImage(oceanFile)
  .then((oceanFile) => {
    const oceanAnimation = new Animation(new SpriteMap(oceanFile, 500, 165))
    const height = oceanAnimation.spriteMap.height*(320/oceanAnimation.spriteMap.width);
    const y = 200/2-(height/2);
    return {
        draw: (interpolationPercentage) => {
          const ctx = computer.graphics.ctx;
          ctx.fillStyle="#000000";
          ctx.fillRect(0, 0, 320, y);
          oceanAnimation.draw(ctx, 0, y, 320);
          ctx.fillRect(0, y+height, 320, 200);
          ctx.drawImage(computer.resources.cursorImg,
            computer.mouse.pos.x,
            computer.mouse.pos.y
          );
        },
        update: (delta) => {
          oceanAnimation.update(delta);
        }
    };
  });
});
